import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { Row, Toast } from "react-bootstrap";
import { getLocaleText } from "../../actions/datagrid";
import { t } from "i18next";
import { gridSettings } from "../../common/grid";
import { hrEsalary } from "../../main";


export function PersonnelStructure() {

  const [showToast, setShowToast] = useState(true);
  const toggleShowToast = () => setShowToast(!showToast);

  const columnDefs = [
    {
      field: "sel",
      headerName: "",
      cellRenderer: "agCheckboxCellRenderer",
      cellEditor: "agCheckboxCellEditor",
      maxWidth: 75,
    },
    {
      headerName: t("Name", "Nimi"),
      field: "name",
      tooltipField: "name",
    },
    {
      headerName: "Kuvaus määrittelystä",
      field: "desc",
      tooltipField: "desc",
    },
  ];
  const rowData = [
    {
      name: "Henkilöstön määrä keskimäärin",
      desc: "Henkilöstön määrä kunkin kuukauden lopussa lasketaan yhteen ja saatu  summa jaetaan kuukausien lukumäärällä. Lasketaan kokopäivätyöllisten  määrää siten, että esimerkiksi kaksi puolipäivästä työntekijää vastaa  yhtä kokoaikaista työntekijää.",
      sel: true,
    },
    {
      name: "Henkilöstön määrä kuukausittain",
      desc: "Henkilöstön määrä kunkin kuukauden lopussa lasketaan yhteen. Lasketaan  kokopäivätyöllisten määrää siten, että esimerkiksi kaksi puolipäivästä  työntekijää vastaa yhtä kokoaikaista työntekijää.",
      sel: true,
    },
    {
      name: "Henkilöstön määrä jakson lopussa",
      desc: "Henkilöstön määrä jakson lopussa. Lasketaan kokopäivätyöllisten määrää  siten, että esimerkiksi kaksi puolipäivästä työntekijää vastaa yhtä  kokoaikaista työntekijää.",
      sel: true,
    },
    {
      name: "Vakituisten ja määräaikaisten työsuhteiden osuus % jakson lopussa",
      desc: "Henkilöstön määrä jakson lopussa. Lasketaan vakituisten ja  määräaikaisten työsuhteiden osuus % siten, että esimerkiksi kaksi  puolipäivästä työntekijää vastaa yhtä kokoaikaista työntekijää.  (vakituisen henkilöstön määrä jakson lopussa / koko henkilöstön määrä  jakson lopussa * 100% ja määräaikaisen henkilöstön määrä jakson lopussa / koko henkilöstön määrä jakson lopussa * 100%.)",
      sel: true,
    },
    {
      name: "Kokoaikaisten ja osa-aikaisten työsuhteiden osuus % jakson lopussa",
      desc: "Henkilöstön määrä jakson lopussa. Lasketaan kokoaikaisten ja  osa-aikaisten työsuhteiden osuus %. (kokoaikaisen henkilöstön määrä  jakson lopussa / koko henkilöstön määrä jakson lopussa * 100% ja  osa-aikaisen henkilöstön määrä jakson lopussa / koko henkilöstön määrä  jakson lopussa * 100%.)",
      sel: true,
    },
    {
      name: "Uudet henkilöt",
      desc: "Henkilöstön määrä kunkin kuukauden lopussa lasketaan yhteen. Lasketaan  kokopäivätyöllisten määrää siten, että esimerkiksi kaksi puolipäivästä  työntekijää vastaa yhtä kokoaikaista työntekijää.",
      sel: true,
    },
    {
      name: "Tulovaihtuvuus %",
      desc: "Jakson aikana alkaneet työsuhteet jaettuna henkilöstön määrä jakson lopussa kerrotaan sadalla.",
      sel: true,
    },
    {
      name: "Lähteneet henkilöt",
      desc: "Henkilöstön määrä kunkin kuukauden lopussa lasketaan yhteen. Lasketaan  kokopäivätyöllisten määrää siten, että esimerkiksi kaksi puolipäivästä  työntekijää vastaa yhtä kokoaikaista työntekijää.",
      sel: true,
    },
    {
      name: "Irtisanottujen työsuhteiden lukumäärä",
      desc: "Jakson aikana irtisanotut työsuhteet (henkilöstä riippuva syy, tuotannolliset ja taloudelliset syyt).",
      sel: true,
    },
    {
      name: "Lähtövaihtuvuus %",
      desc: "Jakson aikana päättyneet työsuhteet jaettuna henkilöstön määrä jakson lopussa kerrotaan sadalla.",
      sel: true,
    },
    {
      name: "Keskimääräinen vaihtuvuus %",
      desc: "Jakson aikana palvelukseen tulleiden henkilöiden määrä + palveluksesta lähteneiden henkilöiden määrä jaettuna kahdella jaettuna henkilöstön määrä jakson lopussa kerrotaan sadalla.",
      sel: true,
    },
    {
      name: "Lähtövaihtuvuus %, oma irtisanoutuminen",
      desc: "Jakson aikana omalla irtisanoutumisella päättyneet työsuhteet jaettuna henkilöstön määrä jakson lopussa kerrotaan sadalla.",
      sel: true,
    },
    {
      name: "Lähtövaihtuvuus %, eläkkeelle siirtyminen",
      desc: "Jakson aikana omalla irtisanoutumisella päättyneet työsuhteet jaettuna henkilöstön määrä jakson lopussa kerrotaan sadalla.",
      sel: true,
    },
    {
      name: "Työsuhteen pituus",
      desc: "Jakson lopussa voimassa olevien työsuhteiden pituus lasketaan työsuhteen aloituspäivästä jakson loppupäivään. 0-4 vuotta, 5-9 vuotta, 10-14  vuotta, 15-19 vuotta, 20-24 vuotta ja yli 25 vuotta. Pituus ilmoitetaan  vuosina.",
      sel: true,
    },
    {
      name: "Keskimääräinen työsuhteen pituus",
      desc: "Keskimääräinen työsuhteen pituus ilmoitetaan vuosina jakson lopun  tilanteen mukaisesti. Työsuhteen pituus lasketaan työsuhteen alkamisesta jakson päättymiseen. Keski-määräinen työsuhteen pituus saadaan  laskemalla yhteen kaikkien työsuhteiden pituudet jakson lopun. tilanteen mukaisesti ja jakamalla yhteissumma koko henkilöstön määrällä per  jakson loppu.",
      sel: true,
    },
    {
      name: "Henkilöstön ikärakenne",
      desc: "Jakson lopussa voimassa olevien työsuhteiden henkilöstön ikärakenne.  20-24 vuotta, 25-29 vuotta, 30-34 vuotta, 40-44 vuotta, 45-49 vuotta,  50-54 vuotta, 55-59 vuotta, 60- 64 vuotta ja yli 65 vuotta.",
      sel: true,
    },
  ];

  return (<>
    { location.hostname !== hrEsalary &&
    <Toast show={showToast} onClose={toggleShowToast} style={{ background: "#E6F3FE" }}>
      <Toast.Header>
        <span style={{fontSize: "150%"}} className="me-1">🛈</span>
        <strong className="me-auto">Henkilöstön rakenteen tietosisältö</strong>
      </Toast.Header>
      <Toast.Body><small>Valitse seuraavasta taulukosta mitä tietoja haluat tuottaa henkilöstökertomukselle.</small></Toast.Body>
    </Toast>
    }
    <Row className="ag-theme-material styles-ag mt-3 flex-grow-1 h-450">
      <AgGridReact
        {...gridSettings}

        //rowSelection={multiRow}
        defaultColDef={{
          flex: 1,
        }}

        columnDefs={columnDefs}
        rowData={rowData}
        enableCellTextSelection
        getLocaleText={params => getLocaleText(t, params)}
      />
    </Row></>);
}
